export const enTranslatedStrings = {
    "category_task_model": "Task model",
    "category_warm_up": "Topic preparation / Warm up",
    "category_developing": "Developing knowledge / abilities",
    "category_vocabulary": "Vocabulary and expressions",
    "category_custom": "Custom",
    "category_task_repetition": "Task repetition / Follow-up task",
    "category_explicit_explanation": "Explicit explanation",
    "category_reflection": "Reflection",
    "category_written_oral": "Written-to-oral / oral-to-written",
    "activity_listening": "Listening",
    "activity_watching": "Watching",
    "activity_reading": "Reading",
    "activity_speaking": "Speaking",
    "activity_writing": "Writing",
    "activity_interaction": "Interaction",
    "activity_exercise": "Exercise",
    "activity_game": "Game",
    "Type of pre/post-task": "Type of pre/post-task",
    "Activity types": "Activity types",
    "Select at least one activity type": "Select at least one activity type",
    "Short text": "Short text",
    "Description (optional)": "Description (optional)",
    "Edit interaction design": "Edit interaction design",
    "Edit Interaction": "Edit Interaction",
    "The exercise designer will be available soon.": "The exercise designer will be available soon.",
    "Edit exercise": "Edit exercise",
    "Exercise configured": "Exercise configured",
    "No exercise yet": "No exercise yet",
    "Exercise name": "Exercise name",
    "Default grade": "Default grade",
    "Penalty": "Penalty",
    "Default grade help": "Points the question is worth in Moodle (its 'default mark'). Usually 1.",
    "Penalty help": "Fraction of the mark subtracted for each wrong retry — only in Moodle's interactive/adaptive mode. Default: 1/3 (0.3333).",
    "Question grade override help": "Points for this question. Leave empty to use the exercise default.",
    "Question penalty override help": "Penalty for this question. Leave empty to use the exercise default.",
    "Exercise type": "Exercise type",
    "exercise_type_questions": "Independent questions",
    "exercise_type_cloze": "Cloze (gaps in text)",
    "The Cloze editor is coming next.": "The Cloze editor is coming next.",
    "Cloze text": "Cloze text",
    "Select a word and turn it into a gap:": "Select a word and turn it into a gap:",
    "Make gap": "Make gap",
    "Select a word in the text first.": "Select a word in the text first.",
    "Gap": "Gap",
    "Clue": "Clue",
    "Correct answer": "Correct answer",
    "Alternatives": "Alternatives",
    "Add alternative": "Add alternative",
    "cloze_gap_gapfill": "Gap-fill",
    "cloze_gap_multichoice": "Multiple choice",
    "cloze_gap_truefalse": "True / False",
    "Add question": "Add question",
    "No questions yet.": "No questions yet.",
    "Statement": "Statement",
    "exercise_qtype_shortanswer": "Short answer",
    "exercise_qtype_essay": "Essay (open answer)",
    "exercise_qtype_truefalse": "True / False",
    "exercise_qtype_multichoice": "Multiple choice",
    "exercise_qtype_matching": "Matching",
    "exercise_qtype_ordering": "Ordering",
    "Open answer — no auto-correction.": "Open answer — no auto-correction.",
    "True": "True",
    "False": "False",
    "Accepted answers": "Accepted answers",
    "Answer": "Answer",
    "Add answer": "Add answer",
    "Case sensitive": "Case sensitive",
    "Allow multiple correct answers": "Allow multiple correct answers",
    "Add option": "Add option",
    "Matching pairs": "Matching pairs",
    "Left": "Left",
    "Right": "Right",
    "Add pair": "Add pair",
    "Items in correct order": "Items in correct order",
    "Add item": "Add item",
    "Exercise saved": "Exercise saved",
    "Saving...": "Saving...",
    "Export": "Export",
    "Moodle (XML)": "Moodle (XML)",
    "Edit Pre-Task": "Edit Pre-Task",
    "Edit Post-Task": "Edit Post-Task",
    "Add text": "Add text",
    "Add image": "Add image",
    "Add audio": "Add audio",
    "Add video": "Add video",
    "Title": "Title",
    "Drag to reorder": "Drag to reorder",
    "Are you sure you want to delete this material?": "Are you sure you want to delete this material?",
    "Please enter a title.": "Please enter a title.",
    "We are working to improve the Taskgen site.": "We are working to improve the Taskgen site.",
    "It will be active again shortly.": "It will be active again shortly.",
    "Thank you for your patience.": "Thank you for your patience.",
    "You don\'t have an account?": "You don\'t have an account?",
    "Register as a new user": "Register as a new user",
    "Register": "Register",
    "University": "University",
    "Secondary school": "Secondary school",
    "Primary school": "Primary school",
    "Private tutoring": "Private tutoring",
    "Online private tutoring": "Online private tutoring",
    "Language school": "Language school",
    "I am not teaching yet": "I am not teaching yet",
    "Face to Face": "Face to Face",
    "Fully online": "Fully online",
    "Hybrid/Blended": "Hybrid/Blended",
    "Task Based Language Teaching": "Task Based Language Teaching",
    "Content and Language Integrate Learning": "Content and Language Integrate Learning",
    "Project-based Learning": "Project-based Learning",
    "Traditional Teaching": "Traditional Teaching",
    "Language for Specific Purposes": "Language for Specific Purposes",
    "Language for Academic Purposes": "Language for Academic Purposes",
    "English as a Medium of Instruction": "English as a Medium of Instruction",
    "Afghanistan": "Afghanistan",
    "Albania": "Albania",
    "Algeria": "Algeria",
    "American Samoa": "American Samoa",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Anguilla" : "Anguilla" ,
    "Antarctica": "Antarctica",
    "Antigua and Barbuda": "Antigua and Barbuda",
    "Argentina": "Argentina",
    "Armenia": "Armenia",
    "Aruba": "Aruba",
    "Australia": "Australia",
    "Austria": "Austria",
    "Azerbaijan": "Azerbaijan",
    "Bahamas (the)": "Bahamas (the)",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesh",
    "Barbados" : "Barbados" ,
    "Belarus": "Belarus",
    "Belgium": "Belgium",
    "Belize": "Belize",
    "Benin": "Benin",
    "Bermuda": "Bermuda",
    "Bhutan": "Bhutan",
    "Bolivia (Plurinational State of)" : "Bolivia (Plurinational State of)" ,
    "Bonaire, Sint Eustatius and Saba" : "Bonaire, Sint Eustatius and Saba" ,
    "Bosnia and Herzegovina": "Bosnia and Herzegovina",
    "Botswana" : "Botswana" ,
    "Bouvet Island": "Bouvet Island",
    "Brazil": "Brazil",
    "British Indian Ocean Territory (the)" : "British Indian Ocean Territory (the)" ,
    "Brunei Darussalam": "Brunei Darussalam",
    "Bulgaria" : "Bulgaria" ,
    "Burkina Faso" : "Burkina Faso" ,
    "Burundi": "Burundi",
    "Cabo Verde": "Cabo Verde",
    "Cambodia" : "Cambodia" ,
    "Cameroon" : "Cameroon" ,
    "Canada": "Canada",
    "Cayman Islands (the)" : "Cayman Islands (the)" ,
    "Central African Republic (the)": "Central African Republic (the)",
    "Chad" : "Chad" ,
    "Chile": "Chile",
    "China": "China",
    "Christmas Island" : "Christmas Island" ,
    "Cocos (Keeling) Islands (the)": "Cocos (Keeling) Islands (the)",
    "Colombia" : "Colombia" ,
    "Comoros (the)": "Comoros (the)",
    "Congo (the Democratic Republic of the)": "Congo (the Democratic Republic of the)",
    "Congo (the)": "Congo (the)",
    "Cook Islands (the)": "Cook Islands (the)",
    "Costa Rica": "Costa Rica",
    "Croatia": "Croatia",
    "Cuba" : "Cuba" ,
    "Curaçao": "Curaçao",
    "Cyprus": "Cyprus",
    "Czechia": "Czechia",
    "Côte d'Ivoire": "Côte d'Ivoire",
    "Denmark": "Denmark",
    "Djibouti" : "Djibouti" ,
    "Dominica" : "Dominica" ,
    "Dominican Republic (the)" : "Dominican Republic (the)" ,
    "Ecuador": "Ecuador",
    "Egypt": "Egypt",
    "El Salvador": "El Salvador",
    "Equatorial Guinea": "Equatorial Guinea",
    "Eritrea": "Eritrea",
    "Estonia": "Estonia",
    "Eswatini" : "Eswatini" ,
    "Ethiopia" : "Ethiopia" ,
    "Falkland Islands (the) [Malvinas]": "Falkland Islands (the) [Malvinas]",
    "Faroe Islands (the)": "Faroe Islands (the)",
    "Fiji" : "Fiji" ,
    "Finland": "Finland",
    "France": "France",
    "French Guiana": "French Guiana",
    "French Polynesia" : "French Polynesia" ,
    "French Southern Territories (the)": "French Southern Territories (the)",
    "Gabon": "Gabon",
    "Gambia (the)" : "Gambia (the)" ,
    "Georgia": "Georgia",
    "Germany": "Germany",
    "Ghana": "Ghana",
    "Gibraltar": "Gibraltar",
    "Greece": "Greece",
    "Greenland": "Greenland",
    "Grenada": "Grenada",
    "Guadeloupe": "Guadeloupe",
    "Guam" : "Guam" ,
    "Guatemala": "Guatemala",
    "Guernsey" : "Guernsey" ,
    "Guinea": "Guinea",
    "Guinea-Bissau": "Guinea-Bissau",
    "Guyana": "Guyana",
    "Haiti": "Haiti",
    "Heard Island and McDonald Islands": "Heard Island and McDonald Islands",
    "Holy See (the)": "Holy See (the)",
    "Honduras" : "Honduras" ,
    "Hong Kong": "Hong Kong",
    "Hungary": "Hungary",
    "Iceland": "Iceland",
    "India": "India",
    "Indonesia": "Indonesia",
    "Iran (Islamic Republic of)": "Iran (Islamic Republic of)",
    "Iraq" : "Iraq" ,
    "Ireland": "Ireland",
    "Isle of Man": "Isle of Man",
    "Israel": "Israel",
    "Italy": "Italy",
    "Jamaica": "Jamaica",
    "Japan": "Japan",
    "Jersey": "Jersey",
    "Jordan": "Jordan",
    "Kazakhstan": "Kazakhstan",
    "Kenya": "Kenya",
    "Kiribati" : "Kiribati" ,
    "Korea (the Democratic People's Republic of)": "Korea (the Democratic People's Republic of)",
    "Korea (the Republic of)": "Korea (the Republic of)",
    "Kuwait": "Kuwait",
    "Kyrgyzstan": "Kyrgyzstan",
    "Lao People's Democratic Republic (the)": "Lao People's Democratic Republic (the)",
    "Latvia": "Latvia",
    "Lebanon": "Lebanon",
    "Lesotho": "Lesotho",
    "Liberia": "Liberia",
    "Libya": "Libya",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lithuania",
    "Luxembourg": "Luxembourg",
    "Macao": "Macao",
    "Madagascar": "Madagascar",
    "Malawi": "Malawi",
    "Malaysia" : "Malaysia" ,
    "Maldives" : "Maldives" ,
    "Mali" : "Mali" ,
    "Malta": "Malta",
    "Marshall Islands (the)": "Marshall Islands (the)",
    "Martinique": "Martinique",
    "Mauritania": "Mauritania",
    "Mauritius": "Mauritius",
    "Mayotte": "Mayotte",
    "Mexico": "Mexico",
    "Micronesia (Federated States of)" : "Micronesia (Federated States of)" ,
    "Moldova (the Republic of)": "Moldova (the Republic of)",
    "Monaco": "Monaco",
    "Mongolia" : "Mongolia" ,
    "Montenegro": "Montenegro",
    "Montserrat": "Montserrat",
    "Morocco": "Morocco",
    "Mozambique": "Mozambique",
    "Myanmar": "Myanmar",
    "Namibia": "Namibia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Netherlands (the)": "Netherlands (the)",
    "New Caledonia": "New Caledonia",
    "New Zealand": "New Zealand",
    "Nicaragua": "Nicaragua",
    "Niger (the)": "Niger (the)",
    "Nigeria": "Nigeria",
    "Niue" : "Niue" ,
    "Norfolk Island": "Norfolk Island",
    "Northern Mariana Islands (the)": "Northern Mariana Islands (the)",
    "Norway": "Norway",
    "Oman" : "Oman" ,
    "Pakistan" : "Pakistan" ,
    "Palau": "Palau",
    "Palestine, State of": "Palestine, State of",
    "Panama": "Panama",
    "Papua New Guinea" : "Papua New Guinea" ,
    "Paraguay" : "Paraguay" ,
    "Peru" : "Peru" ,
    "Philippines (the)": "Philippines (the)",
    "Pitcairn" : "Pitcairn" ,
    "Poland": "Poland",
    "Portugal" : "Portugal" ,
    "Puerto Rico": "Puerto Rico",
    "Qatar": "Qatar",
    "Republic of North Macedonia": "Republic of North Macedonia",
    "Romania": "Romania",
    "Russian Federation (the)" : "Russian Federation (the)" ,
    "Rwanda": "Rwanda",
    "Réunion": "Réunion",
    "Saint Barthélemy" : "Saint Barthélemy" ,
    "Saint Helena, Ascension and Tristan da Cunha" : "Saint Helena, Ascension and Tristan da Cunha" ,
    "Saint Kitts and Nevis": "Saint Kitts and Nevis",
    "Saint Lucia": "Saint Lucia",
    "Saint Martin (French part)": "Saint Martin (French part)",
    "Saint Pierre and Miquelon": "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines" : "Saint Vincent and the Grenadines" ,
    "Samoa": "Samoa",
    "San Marino": "San Marino",
    "Sao Tome and Principe": "Sao Tome and Principe",
    "Saudi Arabia" : "Saudi Arabia" ,
    "Senegal": "Senegal",
    "Serbia": "Serbia",
    "Seychelles": "Seychelles",
    "Sierra Leone" : "Sierra Leone" ,
    "Singapore": "Singapore",
    "Sint Maarten (Dutch part)": "Sint Maarten (Dutch part)",
    "Slovakia" : "Slovakia" ,
    "Slovenia" : "Slovenia" ,
    "Solomon Islands": "Solomon Islands",
    "Somalia": "Somalia",
    "South Africa" : "South Africa" ,
    "South Georgia and the South Sandwich Islands" : "South Georgia and the South Sandwich Islands" ,
    "South Sudan": "South Sudan",
    "Spain": "Spain",
    "Sri Lanka": "Sri Lanka",
    "Sudan (the)": "Sudan (the)",
    "Suriname" : "Suriname" ,
    "Svalbard and Jan Mayen": "Svalbard and Jan Mayen",
    "Sweden": "Sweden",
    "Switzerland": "Switzerland",
    "Syrian Arab Republic" : "Syrian Arab Republic" ,
    "Taiwan": "Taiwan",
    "Tajikistan": "Tajikistan",
    "Tanzania, United Republic of" : "Tanzania, United Republic of" ,
    "Thailand" : "Thailand" ,
    "Timor-Leste": "Timor-Leste",
    "Togo" : "Togo" ,
    "Tokelau": "Tokelau",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinidad and Tobago",
    "Tunisia": "Tunisia",
    "Turkey": "Turkey",
    "Turkmenistan" : "Turkmenistan" ,
    "Turks and Caicos Islands (the)": "Turks and Caicos Islands (the)",
    "Tuvalu": "Tuvalu",
    "Uganda": "Uganda",
    "Ukraine": "Ukraine",
    "United Arab Emirates (the)": "United Arab Emirates (the)",
    "United Kingdom of Great Britain and Northern Ireland (the)": "United Kingdom of Great Britain and Northern Ireland (the)",
    "United States Minor Outlying Islands (the)": "United States Minor Outlying Islands (the)",
    "United States of America (the)": "United States of America (the)",
    "Uruguay": "Uruguay",
    "Uzbekistan": "Uzbekistan",
    "Vanuatu": "Vanuatu",
    "Venezuela (Bolivarian Republic of)": "Venezuela (Bolivarian Republic of)",
    "Viet Nam" : "Viet Nam" ,
    "Virgin Islands (British)" : "Virgin Islands (British)" ,
    "Virgin Islands (U.S.)": "Virgin Islands (U.S.)",
    "Wallis and Futuna": "Wallis and Futuna",
    "Western Sahara": "Western Sahara",
    "Yemen": "Yemen",
    "Zambia": "Zambia",
    "Zimbabwe" : "Zimbabwe",
    "Åland Islands": "Åland Islands",
    "No organization selected.": "No organization selected.",
    "Users groups": "Users groups",
    "New group": "New group",
    "Id": "Id",
    "Name": "Name",
    "Users": "Users",
    "Actions": "Actions",
    "1 user": "1 user",
    "users": "users",
    "No users assigned": "No users assigned",
    "Edit group": "Edit group",
    "Delete group": "Delete group",
    "Enter a name": "Enter a name",
    "Description": "Description",
    "Save": "Save",
    "You are about to delete organization content <strong>{{name}}</strong>. 'This action cannot be undone. Are you sure you want to proceed?": "You are about to delete organization content <strong>{{name}}</strong>. 'This action cannot be undone. Are you sure you want to proceed?",
    "Yes": "Yes",
    "No": "No",
    "Add new group": "Add new group",
    "Conditions of Use": "Conditions of Use",
    "Introduction": "Introduction",
    "The taskGen Project is a three-year research initiative supported by grant PID2020-119009RB-I00 from the Spanish Ministry of Science and Innovation (MCIN) and the National Research Agency (AEI) [Reference: 10.13039/501100011033]. At the University of Barcelona, we have developed the taskGen web-based tool for the automated design of second/foreign language communicative tasks. Participants engaging in the pilot evaluation through the taskGen platform are required to read and agree to the terms outlined below.": "The taskGen Project is a three-year research initiative supported by grant PID2020-119009RB-I00 from the Spanish Ministry of Science and Innovation (MCIN) and the National Research Agency (AEI) [Reference: 10.13039/501100011033]. At the University of Barcelona, we have developed the taskGen web-based tool for the automated design of second/foreign language communicative tasks. Participants engaging in the pilot evaluation through the taskGen platform are required to read and agree to the terms outlined below.",
    "Consent": "Consent",
    "Participants engaging in this pilot evaluation of the taskGen tool implicitly agree to these terms upon logging into the platform.": "Participants engaging in this pilot evaluation of the taskGen tool implicitly agree to these terms upon logging into the platform.",
    "Aim of this research project": "Aim of this research project",
    "The aim is to develop a web-based tool that will assist teachers in the design of second and foreign language tasks. The goal is for the tool to help teacher create, clone, share, download/upload onto teaching platforms, and to analyze texts for the automatic detection of linguistic features. Additionally, the tool can be used for training as it contains aids with information about task design.": "The aim is to develop a web-based tool that will assist teachers in the design of second and foreign language tasks. The goal is for the tool to help teacher create, clone, share, download/upload onto teaching platforms, and to analyze texts for the automatic detection of linguistic features. Additionally, the tool can be used for training as it contains aids with information about task design.",
    "Kind participation": "Kind participation",
    "taskGen users can design, organize, store, and share tasks with other users within the taskGen system. Participation may be stopped at any point. Participants can delete their accounts and leave the system.": "taskGen users can design, organize, store, and share tasks with other users within the taskGen system. Participation may be stopped at any point. Participants can delete their accounts and leave the system.",
    "Types of data to be processed": "Types of data to be processed",
    "During the implementation of the pilot, the tool will process (retrieve, store, produce, relate, analyze and use automatically):": "During the implementation of the pilot, the tool will process (retrieve, store, produce, relate, analyze and use automatically):",
    "From your profile data: educational context, teaching modality, teaching approach, country, years of experience. No information related to your identity will be processed, analysed or shared.": "From your profile data: educational context, teaching modality, teaching approach, country, years of experience. No information related to your identity will be processed, analysed or shared.",
    "System use data: timestamps of platform interaction, mouse-click tracking, text length, choice of pre-task and post-task types, choice of text editing and analysis tools, design options, and use of aids.": "System use data: timestamps of platform interaction, mouse-click tracking, text length, choice of pre-task and post-task types, choice of text editing and analysis tools, design options, and use of aids.",
    "Database Security": "Database Security",
    "Collected data will be securely stored, with access limited to authorized personnel only. Stringent security measures will be employed to protect confidentiality.": "Collected data will be securely stored, with access limited to authorized personnel only. Stringent security measures will be employed to protect confidentiality.",
    "Data retrieval and treatment": "Data retrieval and treatment",
    "Standard and secure data analytics tools will be used to retrieve and analyze the collected data exclusively for research purposes.": "Standard and secure data analytics tools will be used to retrieve and analyze the collected data exclusively for research purposes.",
    "Objectives and legal basis for the processing and treatment of data": "Objectives and legal basis for the processing and treatment of data",
    "The processing and treatment of the data follows the principles of the data protection law (GDPR) 2016-679 of the European Union as well as the Catalan Agency of Data Protection.": "The processing and treatment of the data follows the principles of the data protection law (GDPR) 2016-679 of the European Union as well as the Catalan Agency of Data Protection.",
    "Data will be stored until four years after the end of the project. The treatment of personal data is carried out at/by the General Secretary of Universitat de Barcelona, Gran Via de les Corts Catalanes, 585, 08007 Barcelona. The email address is secretaria.general@ub.edu. You can revoke your consent at any point by contacting the email address above.": "Data will be stored until four years after the end of the project. The treatment of personal data is carried out at/by the General Secretary of Universitat de Barcelona, Gran Via de les Corts Catalanes, 585, 08007 Barcelona. The email address is secretaria.general@ub.edu. You can revoke your consent at any point by contacting the email address above.",
    "Research Purposes and confidentiality": "Research Purposes and confidentiality",
    "The collected data will be used solely for research purposes, enhancing understanding, improving user experience, and informing project development. The results of the project will appear in academic publications and organizations (e.g. Ministry of Education, statistical services, etc.) or in the media with no reference to any data related to participants’ personal information, hence ensuring security, privacy and anonymity. No commercial utilization or third-party sharing will occur.": "The collected data will be used solely for research purposes, enhancing understanding, improving user experience, and informing project development. The results of the project will appear in academic publications and organizations (e.g. Ministry of Education, statistical services, etc.) or in the media with no reference to any data related to participants’ personal information, hence ensuring security, privacy and anonymity. No commercial utilization or third-party sharing will occur.",
    "Ethical Compliance": "Ethical Compliance",
    "The data collection process strictly adheres to ethical standards as set by the University of Barcelona, ensuring responsible handling of information throughout collection, storage, and analysis.": "The data collection process strictly adheres to ethical standards as set by the University of Barcelona, ensuring responsible handling of information throughout collection, storage, and analysis.",
    "Modification of Terms": "Modification of Terms",
    "Terms may be modified during the project, and participants will be notified of any changes.": "Terms may be modified during the project, and participants will be notified of any changes.",
    "By utilizing the platform, participants acknowledge their understanding and agreement with these terms. Failure to comply may result in access termination.": "By utilizing the platform, participants acknowledge their understanding and agreement with these terms. Failure to comply may result in access termination.",
    "If you consider that your rights have not been adequately addressed, you can notify the UB Data Protection Delegate: protecciodedades@ub.edu or Travessera de les Corts, 131-159, Pabellón Rosa, 08028 Barcelona.": "If you consider that your rights have not been adequately addressed, you can notify the UB Data Protection Delegate: protecciodedades@ub.edu or Travessera de les Corts, 131-159, Pabellón Rosa, 08028 Barcelona.",
    "Likewise, you have the right to file a claim with the Catalan Data Protection Authority.": "Likewise, you have the right to file a claim with the Catalan Data Protection Authority.",
    "If you have any questions, you can contact the taskGen team at<br />taskgenproject@gmail.com": "If you have any questions, you can contact the taskGen team at<br />taskgenproject@gmail.com",
    "By accepting these terms and conditions, I hereby certify that I have permission to use and release the materials included in my task designs. I am responsible for the materials that I will be sharing with other users within taskGen.": "By accepting these terms and conditions, I hereby certify that I have permission to use and release the materials included in my task designs. I am responsible for the materials that I will be sharing with other users within taskGen.",
    "The taskGen team<br />University of Barcelona": "The taskGen team<br />University of Barcelona",
    "Data treatment": "Data treatment",
    "Update profile": "Update profile",
    "Profile": "Profile",
    "Logout your taskGen session": "Logout your taskGen session",
    "Logout": "Logout",
    "Check your inbox and follow the instructions to finish your registration.": "Check your inbox and follow the instructions to finish your registration.",
    "There was a problem with the registration. It is possible that a user with the same Email is already registered. Please try again later or write to us at info@taskgen.eu.": "There was a problem with the registration. It is possible that a user with the same Email is already registered. Please try again later or write to us at info@taskgen.eu.",
    "Write your mail address and we\'ll send you an email with instructions to finish your registration.": "Write your mail address and we\'ll send you an email with instructions to finish your registration.",
    "Email Address": "Email Address",
    "By clicking this box, I state that I have read and understood the": "By clicking this box, I state that I have read and understood the",
    "terms and conditions": "terms and conditions",
    "Loading...": "Loading...",
    "A new password has been sent to your inbox. You can change your password in your profile once you log in.": "A new password has been sent to your inbox. You can change your password in your profile once you log in.",
    "There was a problem resetting your password. Please try again later or write to us at info@taskgen.eu.": "There was a problem resetting your password. Please try again later or write to us at info@taskgen.eu.",
    "User or password are not vali": "User or password are not vali",
    "Reset your password": "Reset your password",
    "You don't remember your password?": "You don't remember your password?",
    "Reset it": "Reset it",
    "Login": "Login",
    "We would like to kindly ask you complete you user profile. You will do this only once and you can modify your profile at any point.": "We would like to kindly ask you complete you user profile. You will do this only once and you can modify your profile at any point.",
    "Please, tell us where do you usually teach.": "Please, tell us where do you usually teach.",
    "Please, tell us how do you typically teach.": "Please, tell us how do you typically teach.",
    "Please, tell us your general teaching framework.": "Please, tell us your general teaching framework.",
    "Please, select your country.": "Please, select your country.",
    "Select your country...": "Select your country...",
    "Please complete your profile. Missing fields:": "Please complete your profile. Missing fields:",
    "name": "name",
    "privacy policy": "privacy policy",
    "teaching location": "teaching location",
    "teaching model": "teaching model",
    "teaching framework": "teaching framework",
    "country": "country",
    "region": "region",
    "teaching years": "teaching years",
    "First name(s)": "First name(s)",
    "Family name(s)": "Family name(s)",
    "Other...": "Other...",
    "Special Needs": "Special Needs",
    "Have you ever trained using TBLT?": "Have you ever trained using TBLT?",
    "Region or State": "Region or State",
    "How many years of teaching experience do you have?": "How many years of teaching experience do you have?",
    "Tell us for how long you have been teaching in TLBT": "Tell us for how long you have been teaching in TLBT",
    "Edit profile": "Edit profile",
    "Close window/tab": "Close window/tab",
    "Shared with students": "Shared with students",
    "Shared with teachers": "Shared with teachers",
    "Title": "Title",
    "Authorship": "Authorship",
    "Student's proficiency level": "Student's proficiency level",
    "Aims": "Aims",
    "Pre-Task": "Pre-Task",
    "There are no pre-tasks defined": "There are no pre-tasks defined",
    "Main Tasks": "Main Tasks",
    "There are no tasks": "There are no tasks",
    "Post-Task": "Post-Task",
    "There are no post-tasks": "There are no post-tasks",
    "Close": "Close",
    "Aim and instructions": "Aim and instructions",
    "Last updated": "Last updated",
    "Shared by user": "Shared by user",
    "Shared by group": "Shared by group",
    "Duplicate": "Duplicate",
    "Sharing link copied to your clipboard.": "Sharing link copied to your clipboard.",
    "Edit": "Edit",
    "Share": "Share",
    "Share link": "Share link",
    "Move Up": "Move Up",
    "Move Down": "Move Down",
    "Delete": "Delete",
    "Share task": "Share task",
    "Share with users": "Share with users",
    "Shared with someone at": "Shared with someone at",
    "Search users...": "Search users...",
    "Select the users with whom you want to <strong>share the task</strong>:": "Select the users with whom you want to <strong>share the task</strong>:",
    "Task is shared with the following users:": "Task is shared with the following users:",
    "Share with groups": "Share with groups",
    "Select the groups you want to <strong>share the task</strong>:": "Select the groups you want to <strong>share the task</strong>:",
    "Task is shared with the following groups:": "Task is shared with the following groups:",
    "Cancel": "Cancel",
    "Add formatting rule": "Add formatting rule",
    "Remove": "Remove",
    "Feminine": "Feminine",
    "Masculine": "Masculine",
    "Common": "Common",
    "Invariable": "Invariable",
    "Articles": "Articles",
    "Demonstrative": "Demonstrative",
    "Possessive": "Possessive",
    "Indefinite": "Indefinite",
    "Interrogative": "Interrogative",
    "Relative": "Relative",
    "Numeral": "Numeral",
    "Exclamatory": "Exclamatory",
    "Personal Pronouns": "Personal Pronouns",
    "Wh-determiner": "Wh-determiner",
    "Subordinating Conjunctions": "Subordinating Conjunctions",
    "Neuter": "Neuter",
    "Animate": "Animate",
    "Inanimate": "Inanimate",
    "Singular": "Singular",
    "Plural": "Plural",
    "Nominative": "Nominative",
    "Genitive": "Genitive",
    "Accusative": "Accusative",
    "Dative": "Dative",
    "Instrumental": "Instrumental",
    "Locative": "Locative",
    "Cardinal": "Cardinal",
    "Positive": "Positive",
    "Short form": "Short form",
    "Imperfective": "Imperfective",
    "Perfective": "Perfective",
    "Indicative": "Indicative",
    "Conditional": "Conditional",
    "Finite": "Finite",
    "Infinitive": "Infinitive",
    "Converb": "Converb",
    "Participle": "Participle",
    "Middle": "Middle",
    "1st person": "1st person",
    "2nd person": "2nd person",
    "3rd person": "3rd person",
    "Proper nouns": "Proper nouns",
    "All proper nouns": "All proper nouns",
    "Numerals": "Numerals",
    "All numerals": "All numerals",
    "Particles": "Particles",
    "Aspect": "Aspect",
    "Mood": "Mood",
    "VerbForm": "VerbForm",
    "Voice": "Voice",
    "Animacy": "Animacy",
    "Case": "Case",
    "Number": "Number",
    "Gender": "Gender",
    "Degree": "Degree",
    "Person": "Person",
    "Form": "Form",
    "Tense (morphological)": "Tense (morphological)",
    "Interrogative/Relative": "Interrogative/Relative",
    "Total": "Total",
    "Personal": "Personal",
    "Past": "Past",
    "Present": "Present",
    "Future": "Future",
    "My design": "My design",
    "Teacher version": "Teacher version",
    "Preview": "Preview",
    "Download SCORM": "Download SCORM",
    "Download HTML": "Download HTML",
    "Student version": "Student version",
    "Sessions": "Sessions",
    "Session name": "Session name",
    "Update": "Update",
    "Add session": "Add session",
    "Type": "Type",
    "Clone pre-task": "Clone pre-task",
    "Edit pre-task": "Edit pre-task",
    "Delete pre-task": "Delete pre-task",
    "Are you sure you want to delete the pre-task <strong>": "Are you sure you want to delete the pre-task <strong>",
    "</strong>? This action cannot be undone.": "</strong>? This action cannot be undone.",
    "Are you sure you want to delete the post-task <strong>": "Are you sure you want to delete the post-task <strong>",
    "Pos-Task has been clonned as a Pre-Task.": "Pos-Task has been clonned as a Pre-Task.",
    "Write the name of the task": "Write the name of the task",
    "Task metadata": "Task metadata",
    "Author(s)": "Author(s)",
    "Original authorship": "Original authorship",
    "Task language": "Task language",
    "Catalan": "Catalan",
    "English": "English",
    "Spanish": "Spanish",
    "Russian": "Russian",
    "Language in which the task is designed": "Language in which the task is designed",
    "General aim of the task": "General aim of the task",
    "Specific aim of the task": "Specific aim of the task",
    "Other (please specify)": "Other (please specify)",
    "This information will be especially useful if you intend to share the task.": "This information will be especially useful if you intend to share the task.",
    "New Pre-Task": "New Pre-Task",
    "Use a text for reading comprehension and to highlight language input": "Use a text for reading comprehension and to highlight language input",
    "Text": "Text",
    "Audios are great sources of input.": "Audios are great sources of input.",
    "Audio": "Audio",
    "Videos are excellent sources of ‘multimodal’ input. They present together images, text, and audio in meaningful ways that facilitate second language learning.": "Videos are excellent sources of ‘multimodal’ input. They present together images, text, and audio in meaningful ways that facilitate second language learning.",
    "Video": "Video",
    "Reading comprehension dialogues provide an opportunity for both reading and speaking practice.": "Reading comprehension dialogues provide an opportunity for both reading and speaking practice.",
    "Written dialogue": "Written dialogue",
    "Photos provide excellent opportunities to generate communication and interaction.": "Photos provide excellent opportunities to generate communication and interaction.",
    "Photo": "Photo",
    "Video and audio transcripts provide exposure to rich and meaningful input that can be used in several ways.": "Video and audio transcripts provide exposure to rich and meaningful input that can be used in several ways.",
    "Speech transcript": "Speech transcript",
    "Interaction activities can be used in preparation for the main task.": "Interaction activities can be used in preparation for the main task.",
    "Interaction activity": "Interaction activity",
    "Game": "Game",
    "Warm-ups at the beginning of a lesson may serve as a smooth introduction to the topic/content of the lesson, as an opportunity for learners to progressively switch to the second or foreign language, and as a way to get into the language lesson mood.": "Warm-ups at the beginning of a lesson may serve as a smooth introduction to the topic/content of the lesson, as an opportunity for learners to progressively switch to the second or foreign language, and as a way to get into the language lesson mood.",
    "Warm-up": "Warm-up",
    "Main Task": "Main Task",
    "New Main Task": "New Main Task",
    "New Post-Task": "New Post-Task",
    "Task repetition is known to have a positive impact on all aspects of production and learning.": "Task repetition is known to have a positive impact on all aspects of production and learning.",
    "Task repetition": "Task repetition",
    "Explicit explanations can help solve or consolidate language issues that came up during task performance.": "Explicit explanations can help solve or consolidate language issues that came up during task performance.",
    "Explicit explanation": "Explicit explanation",
    "Written to Oral / Oral to Written": "Written to Oral / Oral to Written",
    "Task model and exercises": "Task model and exercises",
    "Exercises": "Exercises",
    "Shared task": "Shared task",
    "The task <strong>": "The task <strong>",
    "</strong> is already shared with you.": "</strong> is already shared with you.",
    "Do you want to add the task <strong>'": "Do you want to add the task <strong>'",
    "</strong> to the collection of tasks shared with you?": "</strong> to the collection of tasks shared with you?",
    "If you accept this shared task, you will be allowed to clone it to create your own version of the task.": "If you accept this shared task, you will be allowed to clone it to create your own version of the task.",
    "Accept": "Accept",
    "Reject": "Reject",
    "Delete task": "Delete task",
    "You are about to delete the task <strong>": "You are about to delete the task <strong>",
    "</strong>. This action cannot be undone.": "</strong>. This action cannot be undone.",
    "Add new Task Example": "Add new Task Example",
    "Select the tasks you want to add as examples:": "Select the tasks you want to add as examples:",
    "Add selected tasks": "Add selected tasks",
    "Delete Task Example": "Delete Task Example",
    "You are about to delete the task example": "You are about to delete the task example",
    "This action cannot be undone.": "This action cannot be undone.",
    "Are you sure you want to proceed?": "Are you sure you want to proceed?",
    "No task example selected.": "No task example selected.",
    "New Task Example": "New Task Example",
    "Move up": "Move up",
    "Move down": "Move down",
    "Delete task example": "Delete task example",
    "You are not allowed to access this secion.": "You are not allowed to access this secion.",
    "Email": "Email",
    "Group": "Group",
    "Subgroup": "Subgroup",
    "Timestamp": "Timestamp",
    "Add new FAQ": "Add new FAQ",
    "Enter a title": "Enter a title",
    "Weight": "Weight",
    "Enter a weigh": "Enter a weigh",
    "Delete FAQ": "Delete FAQ",
    "You are about to delete FAQ content": "You are about to delete FAQ content",
    "Edit FAQ": "Edit FAQ",
    "Body": "Body",
    "No FAQ selected.": "No FAQ selected.",
    "New FAQ": "New FAQ",
    "Delete feedback": "Delete feedback",
    "You are about to delete feedback content": "You are about to delete feedback content",
    "Feedback management": "Feedback management",
    "Issue": "Issue",
    "Section": "Section",
    "Date": "Date",
    "User": "User",
    "You are not allowed to access this section.": "You are not allowed to access this section.",
    "Add new help": "Add new help",
    "Help items": "Help items",
    "There are no help items defined. Add your first help item.": "There are no help items defined. Add your first help item.",
    "Edit help": "Edit help",
    "Delete user": "Delete user",
    "Add help item": "Add help item",
    "Teaser": "Teaser",
    "More link": "More link",
    "Text for the more link": "Text for the more link",
    "Enter the title": "Enter the title",
    "Examples": "Examples",
    "References": "References",
    "Modify": "Modify",
    "Delete help": "Delete help",
    "You are about to delete help content": "You are about to delete help content",
    "Enter a descriptive name": "Enter a descriptive name",
    "Help item": "Help item",
    "Enter the position of this help content relative to other help contents. The higher the value the lower it will be sorted.": "Enter the position of this help content relative to other help contents. The higher the value the lower it will be sorted.",
    "Edit Help Item": "Edit Help Item",
    "Are you sure you want to delete Help Item named?": "Are you sure you want to delete Help Item named?",
    "No help selected.": "No help selected.",
    "Help management": "Help management",
    "New help": "New help",
    "Add new organization": "Add new organization",
    "Delete organization": "Delete organization",
    "You are about to delete organization content": "You are about to delete organization content",
    "Edit Organization": "Edit Organization",
    "Organizations management": "Organizations management",
    "New organization": "New organization",
    "Edit organizataion": "Edit organizataion",
    "You must generate a password for the user. Use the button below.": "You must generate a password for the user. Use the button below.",
    "You must give the user a role.": "You must give the user a role.",
    "Email address": "Email address",
    "Password": "Password",
    "Student": "Student",
    "Teacher": "Teacher",
    "Administrator": "Administrator",
    "Lastname": "Lastname",
    "Write the name of the user": "Write the name of the user",
    "Write the lastname of the user": "Write the lastname of the user",
    "- Select an organization -": "- Select an organization -",
    "Generate password": "Generate password",
    "You are about to delete user with email": "You are about to delete user with email",
    "All user data and tasks will be deleted. This action cannot be undone.": "All user data and tasks will be deleted. This action cannot be undone.",
    "You must generate or write a password for the user. Use the button below.": "You must generate or write a password for the user. Use the button below.",
    "Users management": "Users management",
    "New user": "New user",
    "Mail": "Mail",
    "Organization": "Organization",
    "Role": "Role",
    "Edit user": "Edit user",
    "Only MP4 videos are allowed.": "Only MP4 videos are allowed.",
    "Add new Video": "Add new Video",
    "Delete Video": "Delete Video",
    "You are about to delete Video content": "You are about to delete Video content",
    "Edit Video": "Edit Video",
    "No Video selected.": "No Video selected.",
    "Video management": "Video management",
    "New Video": "New Video",
    "Beginnings are always difficult": "Beginnings are always difficult",
    "Do not hesitate to contact us with any questions you may have.": "Do not hesitate to contact us with any questions you may have.",
    "Contact us": "Contact us",
    "Check out some of the questions teachers/designers have asked us so far. The answers will help you to get the most of the tool": "Check out some of the questions teachers/designers have asked us so far. The answers will help you to get the most of the tool",
    "Dashboard": "Dashboard",
    "Tasks": "Tasks",
    "Pretasks": "Pretasks",
    "Postasks": "Postasks",
    "Task groups": "Task groups",
    "Task roles": "Task roles",
    "Task prompts": "Task prompts",
    "Text analyzer": "Text analyzer",
    "Help system": "Help system",
    "What is <span>taskGen</span>?": "What is <span>taskGen</span>?",
    "It is an ongoing three-year research project made possible by a grant PID2023-149648NB-I00 funded by the Ministry of Science and Innovation (MCIN) and National Research Agency (AEI) 10.13039/501100011033.": "It is an ongoing three-year research project made possible by a grant PID2023-149648NB-I00 funded by the Ministry of Science and Innovation (MCIN) and National Research Agency (AEI) 10.13039/501100011033.",
    "In this project we are developing and piloting a tool that will help teachers and task and syllabus designers with organizing and automating the design of second/foreign language communicative tasks. If you wish to know more about the project, please click here...": "In this project we are developing and piloting a tool that will help teachers and task and syllabus designers with organizing and automating the design of second/foreign language communicative tasks. If you wish to know more about the project, please click here...",
    "Read more": "Read more",
    "The task has been cloned. You will find the cloned task in \"My Task designs\" in the dashboard": "The task has been cloned. You will find the cloned task in \"My Task designs\" in the dashboard",
    "Wish to design a task?": "Wish to design a task?",
    "or get some inspiration": "or get some inspiration",
    "See some examples": "See some examples",
    "Create a new task": "Create a new task",
    "Shared directly with me": "Shared directly with me",
    "Task examples": "Task examples",
    "<p>Cathoven will automatically <strong>detect the CEFR level</strong> of the text you insert in their text box (up to 250 words if you want to do it for free). You can also <strong>generate exercises</strong> automatically. You <strong>generate new texts</strong> if you insert a topic.<br /> You can copy and paste your classified texts into the taskGen textbox and use the button \"Analyze\" to get a complete linguistic analysis of your text. Then you can select some linguistic feature that are relevant to your task</p>": "<p>Cathoven will automatically <strong>detect the CEFR level</strong> of the text you insert in their text box (up to 250 words if you want to do it for free). You can also <strong>generate exercises</strong> automatically. You <strong>generate new texts</strong> if you insert a topic.<br /> You can copy and paste your classified texts into the taskGen textbox and use the button “Analyze” to get a complete linguistic analysis of your text. Then you can select some linguistic feature that are relevant to your task</p>",
    "<p>You can get some inspiration about possible pre-tasks in the International Task Bank where you can obtain and download full task designs.</p>": "<p>You can get some inspiration about possible pre-tasks in the International Task Bank where you can obtain and download full task designs.</p>",
    "<p>Quizlet is a tool that allows students to learn vocabulary by means of customised flashcards</p>": "<p>Quizlet is a tool that allows students to learn vocabulary by means of customised flashcards</p>",
    "<p>If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free.<br /> You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.</p>": "<p>If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free.<br /> You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.</p>",
    "<p>edpuzzle will let you <strong>create interactive videos</strong> where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.</p>": "<p>edpuzzle will let you <strong>create interactive videos</strong> where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.</p>",
    "<p>The program can <strong>generate videos</strong> on the basis of the topic you choose. You have limited access as a free user.<br /> You can also insert the link in taskGen or upload the audio files you create with these apps.</p>": "<p>The program can <strong>generate videos</strong> on the basis of the topic you choose. You have limited access as a free user.<br /> You can also insert the link in taskGen or upload the audio files you create with these apps.</p>",
    "<p>You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user.</p>": "<p>You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user.</p>",
    "<p>Quizbot will let you <strong>transform an audio file into text</strong> and then <strong>generate questions</strong>.<br /> You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.</p>": "<p>Quizbot will let you <strong>transform an audio file into text</strong> and then <strong>generate questions</strong>.<br /> You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.</p>",
    "<p>Two classic web sites where you can <strong>find movie scripts</strong> and scripts from <strong>TV series</strong>.</p>": "<p>Two classic web sites where you can <strong>find movie scripts</strong> and scripts from <strong>TV series</strong>.</p>",
    "<p>Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function “Analyze” to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)</p>": "<p>Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function “Analyze” to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)</p>",
    "<p>You can <strong>generate new pictures</strong>.</p>": "<p>You can <strong>generate new pictures</strong>.</p>",
    "<p>You can upload a picture and the program will <strong>generate questions</strong> about the picture automatically.</p>": "<p>You can upload a picture and the program will <strong>generate questions</strong> about the picture automatically.</p>",
    "<p>You can use this tool to <strong>have a text be read</strong> by a computerized voice.</p>": "<p>You can use this tool to <strong>have a text be read</strong> by a computerized voice.</p>",
    "<p>You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.</p>": "<p>You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.</p>",
    "<p>You can <strong>get ideas</strong> and example about interaction activities in the International Task Bank.</p>": "<p>You can <strong>get ideas</strong> and example about interaction activities in the International Task Bank.</p>",
    "<p>Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.</p>": "<p>Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.</p>",
    "AI Tools and other resources": "AI Tools and other resources",
    "Sorry! The result of the text analysis is either empty or some errors were found. Revise and change your text and try it again.": "Sorry! The result of the text analysis is either empty or some errors were found. Revise and change your text and try it again.",
    "Pragmatic Expressions": "Pragmatic Expressions",
    "All pragmatic expressions": "All pragmatic expressions",
    "Suggesting": "Suggesting",
    "Thanking": "Thanking",
    "Requesting": "Requesting",
    "Agreeing/Disagreeing": "Agreeing/Disagreeing",
    "Showing interest": "Showing interest",
    "Apologising": "Apologising",
    "Giving an opinion": "Giving an opinion",
    "Greeting": "Greeting",
    "Phrasal verbs": "Phrasal verbs",
    "Word Categories": "Word Categories",
    "Nouns": "Nouns",
    "All nouns": "All nouns",
    "Irregular plurals": "Irregular plurals",
    "Adjectives": "Adjectives",
    "All adjectives": "All adjectives",
    "Comparative adjectives": "Comparative adjectives",
    "Superlative adjectives": "Superlative adjectives",
    "Adverbs": "Adverbs",
    "All adverbs": "All adverbs",
    "Comparative adverbs": "Comparative adverbs",
    "Superlative adverbs": "Superlative adverbs",
    "Wh-adverb": "Wh-adverb",
    "Verbs": "Verbs",
    "All verbs": "All verbs",
    "Irregular verbs": "Irregular verbs",
    "Verb Tense": "Verb Tense",
    "Active": "Active",
    "Present Simple": "Present Simple",
    "Present Perfect": "Present Perfect",
    "Present Perfect Continuous": "Present Perfect Continuous",
    "Past Simple": "Past Simple",
    "Past Continuous": "Past Continuous",
    "Past Perfect": "Past Perfect",
    "Past Perfect Continuous": "Past Perfect Continuous",
    "Future ‘going to’": "Future ‘going to’",
    "Future Simple": "Future Simple",
    "Future Perfect": "Future Perfect",
    "Future Perfect Continuous": "Future Perfect Continuous",
    "Passive": "Passive",
    "Present Simple Passive": "Present Simple Passive",
    "Present Continuous Passive": "Present Continuous Passive",
    "Present Perfect Passive": "Present Perfect Passive",
    "Present Perfect Continuous Passive": "Present Perfect Continuous Passive",
    "Past Simple Passive": "Past Simple Passive",
    "Past Continuous Passive": "Past Continuous Passive",
    "Past Perfect Passive": "Past Perfect Passive",
    "Past Perfect Continuous Passive": "Past Perfect Continuous Passive",
    "Future Simple Passive": "Future Simple Passive",
    "Future Perfect Passive": "Future Perfect Passive",
    "Modal Verbs": "Modal Verbs",
    "Imperative": "Imperative",
    "Prepositions": "Prepositions",
    "Subordinating conjunctions": "Subordinating conjunctions",
    "Determiners": "Determiners",
    "All determiners": "All determiners",
    "Determiner": "Determiner",
    "Wh-Determiner": "Wh-Determiner",
    "Wh-pronouns": "Wh-pronouns",
    "Possessive wh-pronoun": "Possessive wh-pronoun",
    "Possessive Pronouns": "Possessive Pronouns",
    "Contractions": "Contractions",
    "Coordinating Conjunctions": "Coordinating Conjunctions",
    "Clone as Pos-task": "Clone as Pos-task",
    "Clone as Pre-task": "Clone as Pre-task",
    "We are sorry! There was a processing error. Text Analysis is out of order at this moment. Give us some time to recover and try again later.": "We are sorry! There was a processing error. Text Analysis is out of order at this moment. Give us some time to recover and try again later.",
    "hour": "hour",
    "hours": "hours",
    "minute": "minute",
    "minutes": "minutes",
    "second": "second",
    "seconds": "seconds",
    "Previously formatted text": "Previously formatted text",
    "Important": "Important",
    "The tool is still under construction, but give it a try! We\'re working on it.": "The tool is still under construction, but give it a try! We\'re working on it.",
    "processing": "processing",
    "Analyze the text": "Analyze the text",
    "Text analysis": "Text analysis",
    "Text analyzed in": "Text analyzed in",
    "Analysis language": "Analysis language",
    "The text will be analyzed in": "The text will be analyzed in",
    "To change the analysis language, modify the task language in the task metadata section": "To change the analysis language, modify the task language in the task metadata section",
    "read more...": "read more...",
    "Drag and Drop files here": "Drag and Drop files here",
    "Click on the plus icon of each user you want to select:": "Click on the plus icon of each user you want to select:",
    "Users selected:": "Users selected:",
    "Users Groups": "Users Groups",
    "Organizations": "Organizations",
    "Help": "Help",
    "FAQs": "FAQs",
    "Feedbacks": "Feedbacks",
    "Help index": "Help index",
    "Video tutorials": "Video tutorials",
    "To describe an object, person or place": "To describe an object, person or place",
    "To solve a communication problem or gap": "To solve a communication problem or gap",
    "To create a design or plan": "To create a design or plan",
    "To to make a decision or choice": "To to make a decision or choice",
    "To explain a process": "To explain a process",
    "To tell a story": "To tell a story",
    "To reach an agreement": "To reach an agreement",
    "To learn new content (focus on meaning)": "To learn new content (focus on meaning)",
    "To fill out a form": "To fill out a form",
    "To make a complaint": "To make a complaint",
    "To request information": "To request information",
    "To formulate an argument": "To formulate an argument",
    "To express an opinion": "To express an opinion",
    "To foster critical language awareness": "To foster critical language awareness",
    "A1 Movers": "A1 Movers",
    "A2 Key": "A2 Key",
    "B1 Preliminary": "B1 Preliminary",
    "B2 First": "B2 First",
    "C1 Advanced": "C1 Advanced",
    "C2 Proficiency": "C2 Proficiency",
    "Edit Post-Task: Audio": "Edit Post-Task: Audio",
    "Title of the Post-Task": "Title of the Post-Task",
    "Teacher notes": "Teacher notes",
    "Edit Post-Task: Written Dialogue": "Edit Post-Task: Written Dialogue",
    "Edit Post-Task: Exercises": "New Post-Task: Exercises",
    "Edit Post-Task: Explicit Explanation": "New Post-Task: Explicit Explanation",
    "Edit Post-Task: Game": "Edit Post-Task: Game",
    "Edit Post-Task: Interaction Activity": "New Post-Task: Interaction Activity",
    "Edit Post-Task: Photo": "Edit Post-Task: Photo",
    "Edit Post-Task: Repetition": "Edit Post-Task: Repetition",
    "Edit Post-Task: Written to Oral / Oral to Written": "Edit Post-Task: Written to Oral / Oral to Written",
    "Edit Post-Task: Teacher Feedback": "New Post-Task: Teacher Feedback",
    "Edit Post-Task: Text": "Edit Post-Task: Text",
    "Edit Post-Task: Task model and exercises": "New Post-Task: Task model and exercises",
    "Edit Post-Task: Video": "Edit Post-Task: Video",
    "New Post-Task: Audio": "New Post-Task: Audio",
    "New Post-Task: Written Dialogue": "New Post-Task: Written Dialogue",
    "New Post-Task: Exercises": "New Post-Task: Exercises",
    "New Post-Task: Explicit Explanation": "New Post-Task: Explicit Explanation",
    "New Post-Task: Game": "New Post-Task: Game",
    "New Post-Task: Interaction Activity": "New Post-Task: Interaction Activity",
    "New Post-Task: Photo": "New Post-Task: Photo",
    "New Post-Task: Repetition": "New Post-Task: Repetition",
    "New Post-Task: Written to Oral / Oral to Written": "New Post-Task: Written to Oral / Oral to Written",
    "New Post-Task: Teacher Feedback": "New Post-Task: Teacher Feedback",
    "New Post-Task: Text": "New Post-Task: Text",
    "New Post-Task: Task model and exercises": "New Post-Task: Task model and exercises",
    "New Post-Task: Video": "New Post-Task: Video",
    "Resource": "Resource",
    "This post-task has no text": "This post-task has no text",
    "Edit Pre-Task: Interaction activity": "Edit Pre-Task: Interaction activity",
    "Title of the Pre-Task": "Title of the Pre-Task",
    "Edit Pre-Task: Audio": "Edit Pre-Task: Audio",
    "Edit Pre-Task: Written Dialogue": "Edit Pre-Task: Written Dialogue",
    "Edit Pre-Task: Game": "Edit Pre-Task: Game",
    "Edit Pre-Task: Photo": "Edit Pre-Task: Photo",
    "Edit Pre-Task: Speech transcript": "Edit Pre-Task: Speech transcript",
    "Edit Pre-Task: Text": "Edit Pre-Task: Text",
    "Edit Pre-Task: Video": "Edit Pre-Task: Video",
    "Edit Pre-Task: Warm-up": "Edit Pre-Task: Warm-up",
    "New Pre-Task: Interaction activity": "New Pre-Task: Interaction activity",
    "New Pre-Task: Audio": "New Pre-Task: Audio",
    "New Pre-Task: Written Dialogue": "New Pre-Task: Written Dialogue",
    "New Pre-Task: Game": "New Pre-Task: Game",
    "New Pre-Task: Photo": "New Pre-Task: Photo",
    "New Pre-Task: Speech transcript": "New Pre-Task: Speech transcript",
    "New Pre-Task: Text": "New Pre-Task: Text",
    "New Pre-Task: Video": "New Pre-Task: Video",
    "New Pre-Task: Warm-up": "New Pre-Task: Warm-up",
    "No text specified for this pre-task": "No text specified for this pre-task",
    "Prompt": "Prompt",
    "(copy)": "(copy)",
    "Edit Main Task": "Edit Main Task",
    "Add new role": "Add new role",
    "Add new prompt": "Add new prompt",
    "There are no groups": "There are no groups",
    "There are no roles": "There are no roles",
    "There are no prompts defined": "There are no prompts defined",
    "This prompt has no text": "This prompt has no text",
    "Belongs to groups": "Belongs to groups",
    "Are you sure you want to delete the student? This action cannot be undone.": "Are you sure you want to delete the student? This action cannot be undone.",
    "Edit student": "Edit student",
    "Delete student": "Delete student",
    "- Select a role -": "- Select a role -",
    "- Select a prompt -": "- Select a prompt -",
    "Are you sure you want to delete the group? This action cannot be undone.": "Are you sure you want to delete the group? This action cannot be undone.",
    "Change color": "Change color",
    "Add new student": "Add new student",
    "Edit name": "Edit name",
    "Clone": "Clone",
    "Title of the Prompt": "Title of the Prompt",
    "Are you sure you want to delete the prompt? This action cannot be undone.": "Are you sure you want to delete the prompt? This action cannot be undone.",
    "Clone prompt": "Clone prompt",
    "Edit prompt": "Edit prompt",
    "Delete prompt": "Delete prompt",
    "Are you sure you want to delete the role? This action cannot be undone.": "Are you sure you want to delete the role? This action cannot be undone.",
    "Assignments for the role:": "Assignments for the role:",
    "Select the groups this role is assigned to": "Select the groups this role is assigned to",
    "Groups": "Groups",
    "Roles": "Roles",
    "Prompts": "Prompts",
    "Clone task": "Clone task",
    "Edit task": "Edit task",
    "Are you sure you want to delete?": "Are you sure you want to delete?",
    "You are about to delete the task": "You are about to delete the task",
    "The task": "The task",
    "is already shared with you.": "is already shared with you.",
    "Do you want to add the task": "Do you want to add the task",
    "to the collection of tasks shared with you?": "to the collection of tasks shared with you?",
    "Pre-Task has been clonned as a Pos-Task.": "Pre-Task has been clonned as a Pos-Task.",
    "Are you sure you want to delete the post-task?": "Are you sure you want to delete the post-task?",
    "Are you sure you want to delete the pre-task": "Are you sure you want to delete the pre-task",
    "User or password are not valid": "User or password are not valid",
    "Interface language": "Interface language",
    "Log in using your email": "Log in using your email",
    "My task designs": "My task designs",
    "Shared with me": "Shared with me",
    "Log out": "Log out",
    "User groups": "User groups",
    "Feedback": "Feedback",
    "Where do you usually teach?": "Where do you usually teach?",
    "How do you typically teach?": "How do you typically teach?",
    "What's your general teaching framework?": "What's your general teaching framework?",
    "Russian analyzer not available yet": "Russian analyzer not available yet",
    "The Russian text analyzer is not available yet, but it will be soon. We are working on it!": "The Russian text analyzer is not available yet, but it will be soon. We are working on it!",
    "- Select a proficiency level -":"- Select a proficiency level -",
    "- Select a session -":"- Select a session -",
    "- Select a tag -":"- Select a tag -",
    "- Select an aim -":"- Select an aim -",
    "@":"@",
    "Add":"Add",
    "Add help Item":"Add help Item",
    "All pronouns":"All pronouns",
    "Are you sure you want to delete this section? Tasks in this section will be moved to 'Unsectioned'.":"Are you sure you want to delete this section? Tasks in this section will be moved to 'Unsectioned'.",
    "Are you sure you want to delete this tag? This action cannot be undone.":"Are you sure you want to delete this tag? This action cannot be undone.",
    "By clicking this box, I state that I have read and understood the ":"By clicking this box, I state that I have read and understood the ",
    "Create":"Create",
    "Create Section":"Create Section",
    "Create a new section":"Create a new section",
    "DD/MM/YYYY":"DD/MM/YYYY",
    "DD/MM/YYYY hh:mm":"DD/MM/YYYY hh:mm",
    "Delete section":"Delete section",
    "Discard":"Discard",
    "Download DOCX":"Download DOCX",
    "Downloading...":"Downloading...",
    "Edit Section":"Edit Section",
    "Edit section":"Edit section",
    "Enter section name":"Enter section name",
    "Go back":"Go back",
    "If you accept, you will find this task in the 'Shared with me' section. From there you will be able to clone it and create your own version of the task.":"If you accept, you will find this task in the 'Shared with me' section. From there you will be able to clone it and create your own version of the task.",
    "If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free.<br /> You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.":"If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free.<br /> You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.",
    "Language":"Language",
    "Login or register":"Login or register",
    "No prompt assigned":"No prompt assigned",
    "No role assigned":"No role assigned",
    "No tasks in this section":"No tasks in this section",
    "No user selected.":"No user selected.",
    "Not translated":"Not translated",
    "Number of students":"Number of students",
    "Pos-task":"Pos-task",
    "Pre-task":"Pre-task",
    "Print":"Print",
    "Pronouns":"Pronouns",
    "Quizbot will let you <strong>transform an audio file into text</strong> and then <strong>generate questions</strong>.<br /> You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.":"Quizbot will let you <strong>transform an audio file into text</strong> and then <strong>generate questions</strong>.<br /> You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.",
    "Quizlet is a tool that allows students to learn vocabulary by means of customised flashcards":"Quizlet is a tool that allows students to learn vocabulary by means of customised flashcards",
    "Section Name":"Section Name",
    "Students":"Students",
    "Tags":"Tags",
    "Task":"Task",
    "Teachers":"Teachers",
    "Thanks for your feedback.":"Thanks for your feedback.",
    "The program can <strong>generate videos</strong> on the basis of the topic you choose. You have limited access as a free user.<br /> You can also insert the link in taskGen or upload the audio files you create with these apps.":"The program can <strong>generate videos</strong> on the basis of the topic you choose. You have limited access as a free user.<br /> You can also insert the link in taskGen or upload the audio files you create with these apps.",
    "There are no post-tasks defined":"There are no post-tasks defined",
    "There are no prompts":"There are no prompts",
    "There are no tasks defined":"There are no tasks defined",
    "There was a problem uploading files. You can upload a maximum of 5 files simultaneously and not more than 50MB. Try reducing file sizes or uploading fewer files simultaneously. If the problem persists, contact us.":"There was a problem uploading files. You can upload a maximum of 5 files simultaneously and not more than 50MB. Try reducing file sizes or uploading fewer files simultaneously. If the problem persists, contact us.",
    "This tag already exists.":"This tag already exists.",
    "To use this link, you must have a TaskGen account. Go to the login page and access with your account or register.":"To use this link, you must have a TaskGen account. Go to the login page and access with your account or register.",
    "Translations":"Translations",
    "Two classic web sites where you can <strong>find movie scripts</strong> and scripts from <strong>TV series</strong>.":"Two classic web sites where you can <strong>find movie scripts</strong> and scripts from <strong>TV series</strong>.",
    "Unsectioned":"Unsectioned",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.":"Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function “Analyze” to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)":"Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function “Analyze” to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)",
    "Write a tag name":"Write a tag name",
    "Write your mail address and we\\'ll send you an email with instructions to finish your registration.":"Write your mail address and we\\'ll send you an email with instructions to finish your registration.",
    "YYYY-MM-DD":"YYYY-MM-DD",
    "YYYY-MM-DD hh:mm:ss":"YYYY-MM-DD hh:mm:ss",
    "YYYYMMDD":"YYYYMMDD",
    "You can <strong>generate new pictures</strong>.":"You can <strong>generate new pictures</strong>.",
    "You can <strong>get ideas</strong> and example about interaction activities in the International Task Bank.":"You can <strong>get ideas</strong> and example about interaction activities in the International Task Bank.",
    "You can add users of your organization or any user in taskGen.":"You can add users of your organization or any user in taskGen.",
    "You can get some inspiration about possible pre-tasks in the International Task Bank where you can obtain and download full task designs.":"You can get some inspiration about possible pre-tasks in the International Task Bank where you can obtain and download full task designs.",
    "You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user.":"You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user.",
    "You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.":"You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.",
    "You can upload a picture and the program will <strong>generate questions</strong> about the picture automatically.":"You can upload a picture and the program will <strong>generate questions</strong> about the picture automatically.",
    "You can use this tool to <strong>have a text be read</strong> by a computerized voice.":"You can use this tool to <strong>have a text be read</strong> by a computerized voice.",
    "[video ":"[video ",
    "[video=":"[video=",
    "a":"a",
    "edpuzzle will let you <strong>create interactive videos</strong> where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.":"edpuzzle will let you <strong>create interactive videos</strong> where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.",
    "not used":"not used",
    "students":"students",
    "used by":"used by",
    "Search":"Search",
    "Search in all fields...":"Search in all fields...",
    "Searching...":"Searching...",
    "Sort by":"Sort by",
    "Clear filters":"Clear filters",
    "Total results":"Total results",
    "Searching for":"Searching for",
    "Filters":"Filters",
    "Rows per page":"Rows per page",
    "of":"of",
    "Clear":"Clear",
    "Search by email, username, name, organization...":"Search by email, username, name, organization...",
    "Search by organization name...":"Search by organization name...",
    "New version available":"New version available",
    "Version":"Version",
    "is available. Reload to update.":"is available. Reload to update.",
    "Reload":"Reload",
    "Later":"Later",
    "Translate with DeepL":"Translate with DeepL",
    "Translating...":"Translating...",
    "Please enter text to translate":"Please enter text to translate",
    "Cannot translate to English (source language)":"Cannot translate to English (source language)",
    "Please enter English title first":"Please enter English title first",
    "Please enter English body first":"Please enter English body first",
    "Translation error: ":"Translation error: ",
    "You can add translations to other languages after creating the FAQ.":"You can add translations to other languages after creating the FAQ.",
    "DeepL does not support Catalan":"DeepL does not support Catalan",
    "Please enter English teaser first":"Please enter English teaser first",
    "Please enter English examples first":"Please enter English examples first",
    "Please enter English references first":"Please enter English references first",
    "Export User Events":"Export User Events",
    "Export Users":"Export Users",
    "Export Tasks":"Export Tasks",
    "Export Tasks Groups":"Export Tasks Groups",
    "Export NLP Events":"Export NLP Events",
    "Action":"Action",
    "Reference":"Reference",
    "Start":"Start",
    "End":"End",
    "Start date":"Start date",
    "End date":"End date",
    "Duration":"Duration",
    "Teaching location":"Teaching location",
    "Teaching model":"Teaching model",
    "Teaching framework":"Teaching framework",
    "Teaching years":"Teaching years",
    "User ID":"User ID",
    "Number of pre-tasks":"Number of pre-tasks",
    "Number of subtasks":"Number of subtasks",
    "Number of post-tasks":"Number of post-tasks",
    "Number of sessions":"Number of sessions",
    "Cloned":"Cloned",
    "Original source":"Original source",
    "Original task":"Original task",
    "Task name":"Task name",
    "Subtask name":"Subtask name",
    "Number of members":"Number of members",
    "Add new Feedback":"Add new Feedback",
    "Select the functionality of the application about which you want to comment":"Select the functionality of the application about which you want to comment",
    "Subject":"Subject",
    "Write the subject of your comment":"Write the subject of your comment",
    "Comment":"Comment",
    "Leave your comments here":"Leave your comments here",
    "ID":"ID",
    "Country":"Country",
    "Region":"Region",
    "Level":"Level",
    "Proficiency level":"Proficiency level",
    "Option":"Option",
    "Your session has expired. Please log in again.":"Your session has expired. Please log in again.",
    "You do not have permission to perform this action.":"You do not have permission to perform this action.",
    "The requested resource was not found.":"The requested resource was not found.",
    "Server error. Please try again later.":"Server error. Please try again later.",
    "An error occurred. Please try again.":"An error occurred. Please try again.",
    "Network error. Please check your connection.":"Network error. Please check your connection.",
    "Can view":"Can view",
    "Can edit":"Can edit",
    "All can view":"All can view",
    "All can edit":"All can edit",
    "Default":"Default",
    "Show members":"Show members",
    "Hide members":"Hide members",
    "Group members":"Group members",
    "You can edit this task":"You can edit this task",
    "Permission":"Permission",
    "All Tasks":"All Tasks",
    "New subfolder":"New subfolder",
    "New folder":"New folder",
    "New task":"New task",
    "- Tag -":"- Tag -",
    "- Level -":"- Level -",
    "- Aim -":"- Aim -",
    "Icon view":"Icon view",
    "List view":"List view",
    "Create folder":"Create folder",
    "New Folder":"New Folder",
    "Create task":"Create task",
    "New Task":"New Task",
    "This folder is empty":"This folder is empty",
    "Create a new task or folder, or drag items here":"Create a new task or folder, or drag items here",
    "No tasks match the filters":"No tasks match the filters",
    "Try adjusting or clearing the filters":"Try adjusting or clearing the filters",
    "Open":"Open",
    "No members in this group":"No members in this group",
    "Remove from group":"Remove from group",
    "New password":"New password",
    "Confirm password":"Confirm password",
    "Passwords do not match":"Passwords do not match",
    "Password updated successfully.":"Password updated successfully.",
    "This reset link is invalid or has expired.":"This reset link is invalid or has expired.",
    "Back to login":"Back to login",
    "Update password":"Update password",
    "We've sent you an email with a link to reset your password.":"We've sent you an email with a link to reset your password."
}